<div class="mise-en-avant">
  <div class="mise-en-avant_title">
    <div class="mise-en-avant_picture">
      @if (icon != null) {
        <ng-template [ngTemplateOutlet]="icon"></ng-template>
      } @else {
        <i class="icon icon-user"></i>
      }
    </div>
    <div class="mise-en-avant_txt">
      <div class="mise-en-avant_txt-title">
        {{titre}}
      </div>
      @if (sousTitre != null;) {
        <div class="mise-en-avant_txt-subtitle">
          {{sousTitre}}
        </div>
      }
    </div>
  </div>
  <div class="mise-en-avant_content">
    <ul class="mise-en-avant_items">
      <ng-container *ngTemplateOutlet="chips"></ng-container>
    </ul>
    @if (menu && menu.length>0) {
      <div  class="mise-en-avant_action">
        <div #dropdownbtn [items]='menu' (select)="performAction($event.item)"
          class="button-white-icon e-caret-hide"  [disabled]="actionMenuDisabled"
          ejs-dropdownbutton (open)='onOpen($event)'>
          <i class="icon icon-more-vertical"></i>
        </div>
      </div>
    }
  </div>
</div>
